import { Component, Input, SimpleChanges } from '@angular/core';
import './commission-4g-check.component.scss';

@Component({
    selector: 'commission-4g-check',
    template: require('./commission-4g-check.component.html')
})
export class Commission4gCheckComponent {
    @Input() pendingLabel: string;
    @Input() loadingLabel: string;
    @Input() successLabel: string;
    @Input() warningLabel: string;
    @Input() failedLabel: string;
    @Input() infoLabel: string;
    @Input() foldable: boolean;


    icon: string;
    label: string;
    checkStyle: {
        pending: boolean;
        loading: boolean;
        success: boolean;
        warning: boolean;
        info: boolean;
    };

    showDetails = false;
    constructor() { }

    ngOnChanges(changes: SimpleChanges): void {
        this.updateState();
        this.updateStyle();
    }

    toggleDetails(): void {
        this.showDetails = !this.showDetails;
    }

    private updateStyle(): void {
        this.checkStyle = {
            pending: !!this.pendingLabel,
            loading: !!this.loadingLabel,
            success: !!this.successLabel,
            warning: !!this.warningLabel,
            info: !!this.infoLabel
        };
    }

    private updateState(): void {
        switch (true) {
            case !!this.pendingLabel && !this.loadingLabel:
                this.icon = `remove_circle_outline`;
                this.label = this.pendingLabel;
                break;

            case !!this.loadingLabel:
                this.icon = "loop";
                this.label = this.loadingLabel;
                break;

            case !!this.successLabel:
                this.icon = `check_circle`;
                this.label = this.successLabel;
                break;

            case !!this.infoLabel:
                this.icon = "info";
                this.label = this.infoLabel;
                break;

            case !!this.warningLabel:
                this.icon = "warning";
                this.label = this.warningLabel;
                this.showDetails = true;
                break;

            default:
                //failed
                this.icon = `highlight_off`;
                this.label = this.failedLabel;
                this.showDetails = true;
                break;
        }
    }
}
